import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-matches-container',
  templateUrl: './matches-container.component.html',
  styleUrls: ['./matches-container.component.scss']
})
export class MatchesContainerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
